<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
            <div class="title row">
              <div class="col-8">
                {{$t('Orders.Transactions')}} ( {{items.length}} )
              </div>
              <div class="col-4" style="text-align: right;">
                <select v-model="selected_status" @change="statusFilter" style="height: 35px;font-size: 14px;border-radius: 5px;border: 1px solid #ccc;padding: 0 10px;">
                  <option :value="-1">{{$t('Orders.DisplayAll')}}</option>
                  <option :value="0">{{$t('Orders.NotProcessed')}}</option>
                  <option v-for="status in statuses" :key="'status-'+status.id" :value="status.id">{{status.name}}</option>
                </select>
              </div>
            </div>
            <CAlert
              :show.sync="dismissCountDown"
              color="primary"
              fade
            >
              ({{dismissCountDown}}) {{ message }}
            </CAlert>
            <CDataTable
              hover
              :items="items"
              :fields="fields"
              :items-per-page="10"
              pagination
              columnFilter
              tableFilter
              sorter
            >
              <template #user="{item}">
                <td>
                  <strong>{{item.user_data.name}}</strong>
                </td>
              </template>

              <template #adress="{item}">
                <td>
                  <span>
                    <b>{{item.address_data.building_name}}</b>: <br>
                    {{item.address_data.region}}, {{item.address_data.city}}, {{item.address_data.line_1}}, {{item.address_data.line_2}}
                    {{item.address_data.postcode}}
                  </span>
                </td>
              </template>
              
              <template #price="{item}">
                <td v-if="!item.is_paid">
                  <strong>{{item.total_price}}<sup>DT</sup></strong>
                </td>
                <td v-else>
                  <del>{{item.total_price}}<sup>DT</sup></del><br>
                  <strong>{{item.total_price-item.payed_ammount}}<sup>DT</sup></strong>
                  <!-- <p v-if="item.coupon_id" style="color: green;">Coupon utilisé</p> -->
                </td>
              </template>

              <template #paid="{item}">
                <td v-if="!item.is_paid">
                  <span>--</span>
                </td>
                <td v-else>
                  <strong style="color: green;">{{item.payed_ammount}}<sup>DT</sup></strong>
                </td>
              </template>

              <template #status="{item}">
                <td>
                  <span v-if="item.status && item.status_id!=0" class="badge" :style="'background: '+item.status.color+';color: #fff;'">{{item.status.name}}</span>
                  <span v-else class="badge" :style="'background: #888;color: #fff;'">{{$t('Orders.NotProcessed')}}</span>
                </td>
              </template>

              <!-- <template #products="{item}">
                <td>
                  <a href="">Voir les produits&nbsp;({{item.products.length}})</a>
                </td>
              </template> -->

              <template #add="{item}">
                <td>
                  <span>{{item.created_at}}</span>
                </td>
              </template>

              <template #modify="{item}">
                <td>
                  <span>{{item.updated_at}}</span>
                </td>
              </template>
              
              <template #Options="{item}">
                <td class="text-right">
                  <CButton color="info" class="options" @click="$router.push('/admin/transactions/'+item.id+'/manage')"><CIcon name="cil-center-focus" height="48"/> </CButton>
                  <!-- <CButton color="info" @click="$router.push('transactions/'+item.id+'/update')" class="options"><CIcon name="cil-center-focus" height="48"/> </CButton> -->
                  <!-- <CButton color="warning" class="options" @click="manageModalStatus(item)"><CIcon name="cil-pencil" height="48"/> </CButton> -->
                  <!-- <CButton v-if="you!=item.id" color="danger" @click="deleteToast( item )" class="options"><CIcon name="cil-trash" height="48"/> </CButton> -->
                </td>
              </template>
            </CDataTable>
        </CCardBody>  
      </CCard>
      </transition>
    </CCol>
        <vue-confirm-dialog></vue-confirm-dialog>
        <modal 
              :width="'80%'" 
              :minWidth="300"
              :height="'auto'" 
              :name="'modal'"
              :styles="{
                zIndex: 99999
              }"
        >
          <div class="modal-div" style="padding: 20px 50px;max-height: 500px !important;overflow-x: hidden;">
            <div class="title">
              {{selected}}
            </div>
          </div>
        </modal>
  </CRow>
</template>

<script>
import { orderService, transactionService, statusesService } from '../../_services';
import moment from 'moment'

export default {
  name: 'Notes',
  data: () => {
    return {
      items: [],
      /*
      fields: [
        {key: 'author'},
        {key: 'title'},
        {key: 'content'},
        {key: 'applies_to_date'},
        {key: 'status'},
        {key: 'note_type'},
        {key: 'show'},
        {key: 'edit'},
        {key: 'delete'}
      ],
      */
      fields: [
        {key: 'user', label: 'Utilisateur'},
        {key: 'adress', label: 'Adresse'},
        {key: 'price', label: 'Prix'},
        {key: 'paid', label: 'Pre payé'},
        {key: 'status', label: 'Etat'},
        // {key: 'products', label: 'Produits acheté'},
        {key: 'add', label: 'Date du commande'},
        {key: 'modify', label: 'Dérniere MAJ'},
        {key: 'Options', label: 'Options', sorter: false, filter: false},
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      selected: null,

      selected_status: -1,
      statuses: []
    }
  },
  computed: {
  },
  methods: {
    statusFilter(){
      if(this.selected_status==-1){
        this.getProducts()
      }else{
        let self = this;
        this.loader = this.$loading.show();
        transactionService.getAllByStatus(this.selected_status).then(function (response) {
          self.items = response.data.map((obj)=>{
              obj.created_at= moment(obj.created_at).format('DD MMMM YYYY \n HH:mm:ss')
              obj.updated_at= moment(obj.updated_at).format('DD MMMM YYYY \n HH:mm:ss')
              obj.user_data= JSON.parse(obj.user_data)
              obj.address_data= JSON.parse(obj.address_data)
              return obj
          });
        }).finally(function () {
          this.loader.hide();
        }.bind(this));
      }
    },
    manageModal(data){
      this.selected= data;
      this.$modal.show('modal')
    },
    getRowCount (items) {
      return items.length
    },
    noteLink (id) {
      return `notes/${id.toString()}`
    },
    editLink (id) {
      return `product/${id.toString()}/edit`
    },
    showNote ( id ) {
      const noteLink = this.noteLink( id );
      this.$router.push({path: noteLink});
    },
    editNote ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    deleteNote ( id ) {
      this.loader = this.$loading.show();
    
      transactionService.delete(id).then(function(data){
        this.items = data.data.data.map((obj)=>{
            obj.created_at= moment(obj.created_at).format('DD MMMM YYYY')
            obj.updated_at= moment(obj.updated_at).format('DD MMMM YYYY')
            return obj
        });
      }.bind(this)).finally(
          function () {
            this.loader.hide();
          }.bind(this)
      );
    },
    createProduct () {
      this.$router.push({path: 'transactions/create'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getProducts (){
      let self = this;
      this.loader = this.$loading.show();
      orderService.getAllByUser().then(function (response) {
        self.items = response.data.map((obj)=>{
            obj.created_at= moment(obj.created_at).format('DD MMMM YYYY \n HH:mm:ss')
            obj.updated_at= moment(obj.updated_at).format('DD MMMM YYYY \n HH:mm:ss')
            obj.user_data= JSON.parse(obj.user_data)
            obj.address_data= JSON.parse(obj.address_data)
            return obj
        });
      }).finally(function () {
        this.loader.hide();
      }.bind(this));
    },
    deleteToast(item){
      this.$confirm(
        {
          title: `Confirmation!`,
          message: 'êtes-vous sûr de supprimer la marque \''+item.name+'\'?',
          button: {
            no: 'Annuler',
            yes: 'Supprimer'
          },
          /**
          * Callback Function
          * @param {Boolean} confirm 
          */
          callback: confirm => {
            if (confirm) {
              this.deleteNote(item.id)
            }
          }
        }
      )
    }
  },
  mounted: function(){
    this.getProducts();

    statusesService.getAll().then(function (response) {
      this.statuses = response.data
    }.bind(this))
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.badge{
  padding: 5px 10px;
  font-size: 9px;
}
.options{
  margin-right: 5px;
  margin-bottom: 5px;
}
.title{
  padding: 0 0 20px 5px;
  font-size: 20px;
}
</style>
